// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
var __webpack_exports__ = __webpack_require__("./Scripts/app/MainWorkspace/mainWorkspace.main.js");
